export default __webpack_public_path__ + "static/5-380ee8ae6c7c77ca7626e1a40dfb1815.jpeg";